import Vue from 'vue'
import VueTableDynamic from 'vue-table-dynamic'

Vue.use(VueTableDynamic)